import instance from "../Config/Config";


export const DIGITAL_SCHEME_PLAN = "get_digital_plan"
export const ADDTOCART = "add_to_cart"
export const cartList = "get_cart_list"
export const RemoveList = "remove_cart"




export const Digitalscheme_fun = async()=>{
       const response = await instance.get(`${DIGITAL_SCHEME_PLAN}`)
       return response?.data
}

export const Addtocart_fun = async(value)=>{
       const response = await instance.post(`${ADDTOCART}`,value)
       return response?.data
}

export const GetCartList_Fun= async()=>{
       const response = await instance.get(`${cartList}`)
       return response?.data
}

export const Removetocart_fun = async(value)=>{
       const response = await instance.delete(`${RemoveList}`,value)
       return response?.data
}

